module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/174.dd2e7096.png";